/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：348
 */

module.exports = {
  dataViewerGrid: "styles_dataViewerGrid__18qx8",
  gridInfo: "styles_gridInfo__31E01",
  uniqueText: "styles_uniqueText__IVbh6",
  btn: "styles_btn__2drmJ",
  uniqueSelect: "styles_uniqueSelect__3eKOe",
  importFile: "styles_importFile__KHaOI",
  importFileBtn: "styles_importFileBtn__1I3xn",
  grid: "styles_grid__JBx7Q",
  gridName: "styles_gridName__2HPY5",
  gridNameEditorContainer: "styles_gridNameEditorContainer__3cHPk",
  gridNameEditor: "styles_gridNameEditor__3zZ1p",
  invalidGridName: "styles_invalidGridName__8C_Xw",
  warningMessage: "styles_warningMessage__1y2eI",
  uploadButton: "styles_uploadButton__1w52s",
  loadingArea: "styles_loadingArea__30o7B",
  titleArea: "styles_titleArea__1GIea",
  title: "styles_title__2eTMt",
  titleBtn: "styles_titleBtn__22tWL",
  dev: "styles_dev__286h8",
  prod: "styles_prod__2hPJE",
  btnContent: "styles_btnContent__1NAaL",
  importContent: "styles_importContent__r5jSN"
}
